var React = require('react');

function EmptyCreditCard (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M718.14 30.87q26 0 44.5 18.51t18.51 44.5V572.8q0 26-18.51 44.5t-44.5 18.51H88q-26 0-44.5-18.51T25 572.8V93.89q0-26 18.51-44.5T88 30.87zM88 81.28a12.78 12.78 0 00-12.6 12.6v88.22h655.34V93.89a12.78 12.78 0 00-12.6-12.6zm630.14 504.13a12.78 12.78 0 0012.6-12.6V333.34H75.38V572.8A12.78 12.78 0 0088 585.41zM125.8 535v-50.42h100.82V535zm151.2 0v-50.42h151.27V535z"}));
}

EmptyCreditCard.defaultProps = {"viewBox":"0 0 800 660"};

module.exports = EmptyCreditCard;

EmptyCreditCard.default = EmptyCreditCard;
